import { render, staticRenderFns } from "./LoginRecovery.vue?vue&type=template&id=778bc7a9"
import script from "./LoginRecovery.vue?vue&type=script&lang=ts"
export * from "./LoginRecovery.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports